"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _insertScript = _interopRequireDefault(require("../utils/insertScript"));

var _scriptsDone = _interopRequireDefault(require("../utils/scriptsDone"));

var _scriptTypes = _interopRequireDefault(require("../utils/scriptTypes"));

var _sequence = _interopRequireDefault(require("../utils/sequence"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runScripts = function runScripts(element) {
  var scripts = element.querySelectorAll("script");
  var runList = [];
  var typeAttribute;
  [].forEach.call(scripts, function (script) {
    typeAttribute = script.getAttribute("type");

    if (!typeAttribute || _scriptTypes.default.indexOf(typeAttribute) !== -1) {
      runList.push(function (callback) {
        (0, _insertScript.default)(script, callback);
      });
    }
  });
  if (runList.length === 0) return;
  (0, _sequence.default)(runList, _scriptsDone.default);
};

var _default = runScripts;
exports.default = _default;